export default __webpack_public_path__ + "static/media/qta.52b6715f.svg";